import React, { PureComponent, Fragment } from 'react';
import classNames from 'classnames';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import { Video, Picture } from 'formlabs-web-components/Media';
import { Grid } from 'formlabs-web-components/Grid';
import TextPlugin from '../cms/TextPlugin';

import clientOnly from '../../hoc/clientOnly';
import './VideoScrollSection.module.css';

class VideoScrollSection extends PureComponent {
  state = {
    mobile: false,
    scrollLock: false,
    scrollLockBottom: false
  };

  componentDidMount() {
    window.addEventListener('resize', this.debouncedResize);
    window.addEventListener('scroll', this.throttledScroll);
    window.addEventListener('resize', this.calcVidDims);
    this.resize();
    !this.state.mobile && this.calcVidDims();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedResize);
    window.removeEventListener('scroll', this.throttledScroll);
    window.removeEventListener('resize', this.calcVidDims);
  }

  calcVidDims = () => {
    const video = {};
    video.el = document.querySelector('.wc-video--1 video');
    const length = 5;
    video.height = window.innerHeight * 0.8;
    video.length = video.height * length;
    video.end = video.length;
    this.setState({ videoStats: video });
  };

  resize = () => {
    this.setState({ mobile: window.innerWidth <= 1050 });
  };
  scrollState = () => {
    const { mobile, position } = this.state;
    if (!mobile) {
      const scrollVideo = document.querySelector('.wc-slide-2 video');
      const scrollVideoContainer = document.querySelector('.wc-slide-2');
      const bottomScroll = scrollVideoContainer.getBoundingClientRect();

      this.setState({
        position: bottomScroll.top * -1
      });
      this.setState({
        scrollLock:
          bottomScroll.top < 0 && bottomScroll.bottom >= window.innerHeight,
        scrollLockBottom: bottomScroll.bottom <= window.innerHeight,
        bottomScroll: bottomScroll.bottom
      });

      const videoPosition =
        (position >= 0 ? position : 0) *
        ((scrollVideo.duration / scrollVideoContainer.offsetHeight) * 2);

      if (videoPosition) {
        scrollVideo.currentTime = videoPosition;
      }
    }
  };

  debouncedResize = debounce(this.resize, 100);
  throttledScroll = throttle(this.scrollState, 100);

  render() {
    const { video, posterImage, fullWidth = false, children } = this.props;

    const { scrollLock, videoStats, scrollLockBottom } = this.state;

    const width = fullWidth ? 'full' : 'half';

    return (
      <Fragment>
        {!this.state.mobile && (
          <section
            className="wc-slide-2"
            styleName="section-scroll "
            style={videoStats ? { height: videoStats.length } : {}}
          >
            <div
              styleName={classNames('video-container', {
                locked: scrollLock,
                'locked-bottom': scrollLockBottom
              })}
            >
              <div styleName="position-correction">
                <Grid direction="x" hasContainer={!fullWidth}>
                  <div className="wc-video wc-video--1" styleName={width}>
                    <Video
                      src={video}
                      autoPlay={false}
                      loop={false}
                      poster={posterImage}
                    />
                  </div>
                  <div styleName={width}>
                    <div styleName="vertical-center">
                      <div>{children}</div>
                    </div>
                  </div>
                </Grid>
              </div>
              <div className="" />
            </div>
          </section>
        )}{' '}
        {this.state.mobile && (
          <div styleName="section-scroll">
            <Grid direction="x" hasContainer={true}>
              {posterImage && (
                <div style={{ textAlign: 'center', width: '100%' }}>
                  <Picture largeImage={posterImage} />
                </div>
              )}
              <div>{children}</div>
            </Grid>
          </div>
        )}
      </Fragment>
    );
  }
}

export default clientOnly(VideoScrollSection);
